import React from 'react';
export function VideoSection() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3268">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3269">
        <div className="mb-12" data-id="element-3270">
          <h2 className="text-2xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3271">
            Class Preview
          </h2>
          <div className="relative w-full rounded-xl overflow-hidden shadow-md bg-black" style={{
          paddingBottom: '56.25%'
        }} data-id="element-3272">
            <iframe className="absolute inset-0 w-full h-full" src="https://www.youtube.com/embed/95wBvm9lxKk" title="FLSC Self Defense Class Feb 2024" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen data-id="element-3273" />
          </div>
        </div>
      </div>
    </div>;
}